"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConstantProvider = void 0;
const day_names_1 = require("./../constant-values/day-names");
const month_names_1 = require("./../constant-values/month-names");
class ConstantProvider {
    static getDayNames(locale) {
        if (locale in day_names_1.DayNames)
            return day_names_1.DayNames[locale];
        else
            return day_names_1.DayNames["default"];
    }
    static getMonthNames(locale) {
        if (locale in month_names_1.MonthNames)
            return month_names_1.MonthNames[locale];
        else
            return month_names_1.MonthNames["default"];
    }
}
exports.ConstantProvider = ConstantProvider;
